module.exports = __webpack_public_path__ + "img/icon_offer.ac2a5c5d.png";